<script setup>
import { ref, onMounted } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "@/stores/storeFieldData";
import BasePhoneInput from "@/components/ui/BasePhoneInput.vue";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";

const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const storeField = useFieldsStore();

onMounted(async () => {
	
});
</script>
<template>
	<section class="events section">
		<div class="container">
			<div class="events__header">
				<h2 class="events__title title2"><span class="title-border">Проведение</span> мероприятий</h2>
				<p>
					Если вы задумали провести турнир, корпоративные состязания или семейный праздник — The Rink Fitness предлагает живописную уличную инфраструктуру с игровыми площадками для большого тенниса, падел-тенниса, петанка и пинг-понга. Вы можете организовать свое мероприятие под живую музыку, сопроводить изысканным фуршетом, пригласить лекторов или звезд спорта. Для получения подробной информации свяжитесь с нами любым удобным для вас способом.
				</p>
			</div>
			<div class="events__container">
				<form class="events__form">
					<h6 class="title6 events__form-title">
						Оставьте свои контакты <br />
						и мы с вами свяжемся
					</h6>
					<BasePhoneInput 
						:required="true"
						placeholder="+7 (___) ___ ____"  
						state-key="phone"
					>
							Номер телефона
					</BasePhoneInput>
					<BaseCheckbox
						:required="true" 
						state-key="agreement"
					>
						Ознакомлен с
						<a :href="storeSettings.settings.documents?.rules" target="_blank">правилами клуба</a>						
						, согласен с 
						<a :href="storeSettings.privacy_policy" target="_blank" rel="noopener noreferrer">политикой обработки персональных данных</a>
					</BaseCheckbox>
					<button 
						:disabled="storeField.isBtnDisabled(['phone', 'agreement'])" 
						:class="['events__btn form__btn btn', { 'not-hover': storeRequests.loaderBtn }]" 
						@click="storeRequests.contactPhoneNumberForFeedback()"
						type="button"
						>
						<span v-if="!storeRequests.loaderBtn">Отправить</span>
						<img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader.svg" alt="изображение" />
					</button>
					<p class="form-text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>					
					<p class="form-text-ok" :class="{active: storeRequests.responseOk}" v-if="storeRequests.responseOk">Ваша заявка отправлена</p>

				</form>
				<div class="events__images">
					<img class="full-img" width="579" height="698" src="@/assets/img/events/events_1.webp" srcset="@/assets/img/events/events_1@2x.webp 2x" alt="изображение" />
					<img class="full-img" width="579" height="698" src="@/assets/img/events/events_2.webp" srcset="@/assets/img/events/events_2@2x.webp 2x" alt="изображение" />
					<img class="full-img" width="578" height="460" src="@/assets/img/events/events_3.webp" srcset="@/assets/img/events/events_3@2x.webp 2x" alt="изображение" />
					<img class="full-img" width="578" height="460" src="@/assets/img/events/events_4.webp" srcset="@/assets/img/events/events_4@2x.webp 2x" alt="изображение" />
					<img class="full-img" width="578" height="460" src="@/assets/img/events/events_5.webp" srcset="@/assets/img/events/events_5@2x.webp 2x" alt="изображение" />
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
	.form-text-ok {
		&.active {
			animation: anim 0.5s ease-out 2s forwards;
		}
	}
	@keyframes anim {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
</style>
